import React from 'react';
import {StaticQuery, graphql} from 'gatsby';
import {Container, Row, Col} from 'react-bootstrap';
import {injectIntl} from "gatsby-plugin-intl";
import ResourcesData from "../../content/home/resources.json"
import CasesData from "../../content/case-studies/index.json"
import PapersData from "../../content/white-papers/index.json"
import SimpleCard from "../misc/simple-card";

const LastBlogPost = props => (

    <StaticQuery
        query={graphql`
          query {
            allMdx(
                  sort: { fields: [fields___publishDate], order: DESC }
                  limit: 1
                  filter: {
                    frontmatter: { pageType: { eq: "blog" } }
                    fields: { published: { eq: true } }
                  }
                ) {
              edges {
                node {
                  fields {
                    slug
                    publishDate
                    cover
                  }
                  frontmatter {
                    title
                    cover
                  }
                }
              }
            }
          }
        `}
        render={data => {
            let post = data.allMdx.edges[0],
                card = {
                    image: post.node.fields.cover,
                    title: props.content.title,
                    text: post.node.frontmatter.title,
                    button: {
                        label: props.content.text,
                        url: post.node.fields.slug
                    }
                };
            return (
                <SimpleCard content={card}/>
            );
        }}
    />
);

injectIntl(LastBlogPost);


class HomeResources extends React.Component {

    constructor(props, context){
        super(props, context);

        this.state = {
            lastCase: {
                image: CasesData[props.intl.locale].cases[0].image ,
                title: ResourcesData[props.intl.locale].titles.cases,
                text: CasesData[props.intl.locale].cases[0].title,
                button: {
                    label: CasesData[props.intl.locale].cases[0].button.label,
                    url: CasesData[props.intl.locale].cases[0].button.url
                }
            },
            lastPaper: {
                image: PapersData[props.intl.locale].papers[0].image ,
                title: ResourcesData[props.intl.locale].titles.whitePapers,
                text: PapersData[props.intl.locale].papers[0].title,
                button: {
                    label: PapersData[props.intl.locale].papers[0].button.label,
                    url: PapersData[props.intl.locale].papers[0].button.url
                }
            },
            // lastPaper: {
            //     image: CasesData[props.intl.locale].cases[1].image ,
            //     title: ResourcesData[props.intl.locale].titles.cases,
            //     text: CasesData[props.intl.locale].cases[1].title,
            //     button: {
            //         label: CasesData[props.intl.locale].cases[1].button.label,
            //         url: CasesData[props.intl.locale].cases[1].button.url
            //     }
            // }
        };
    }
    render() {
        return (
            <div className={`resources-highlights`}>
                <Container>
                    <div className={`title`}>{ResourcesData[this.props.intl.locale].title}</div>
                    <Row>
                        <Col lg={4}>
                            <LastBlogPost content={{title: ResourcesData[this.props.intl.locale].titles.blog, text:this.props.intl.formatMessage({id: "shared.readMore"})}} />
                        </Col>
                        <Col lg={4}>
                            <SimpleCard content={this.state.lastCase} />
                        </Col>
                        <Col lg={4}>
                            <SimpleCard content={this.state.lastPaper} />
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default injectIntl(HomeResources)
